module.exports = __webpack_public_path__ + "static/scale-model-of-sing-the-queen-city-sign-in-cincinnati-ohio-41ca015debc5eb5ab662a7f91b5ca6ae.png";